/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { injectable } from 'inversify';
import type { PlanningEntity } from './PlanningEntity';
import type { PlanningEntityFactory } from './PlanningEntityFactory';
import type { MCSData } from '../Serialization/MCSD/m-c-s-data';

@injectable()
export class PlanningEntityRegistry {
  private _registry?: Map<string, PlanningEntity>;

  public init(header: MCSData, entityFactory: PlanningEntityFactory): void {
    this._registry = new Map();
    for (let i = 0, sz = header.meshesLength(); i < sz; ++i) {
      const entry = header.meshes(i)!;
      const entity = entityFactory.createEntity(entry.label()!);
      if (entity && !this._registry.has(entity.descriptor)) {
        this._registry.set(entity.descriptor, entity);
      }
    }
    for (let i = 0, sz = header.pointsLength(); i < sz; ++i) {
      const entry = header.points(i)!;
      const entity = entityFactory.createEntity(entry.label()!);
      if (entity && !this._registry.has(entity.descriptor)) {
        this._registry.set(entity.descriptor, entity);
      }
    }
    for (let i = 0, sz = header.splinesLength(); i < sz; ++i) {
      const entry = header.splines(i)!;
      const entity = entityFactory.createEntity(entry.label()!);
      if (entity && !this._registry.has(entity.descriptor)) {
        this._registry.set(entity.descriptor, entity);
      }
    }
  }

  public getAll(): Map<string, PlanningEntity> {
    if (!this._registry) {
      throw new Error('Not initialized');
    }
    return this._registry;
  }

  public getByDescriptor(descriptor: string): PlanningEntity | undefined {
    return this.getAll().get(descriptor);
  }

  public hasEntity(descriptor: string): boolean {
    return this.getAll().has(descriptor);
  }

  public addEntity(descriptor: string, entity: PlanningEntity): void {
    this.getAll().set(descriptor, entity);
  }

  public removeEntity(descriptor: string): void {
    this.getAll().delete(descriptor);
  }
}
